import React, { Component } from "react";
import { FormValidate } from "../../../../../components/formValidate";
import CustomButton from "../../../../../components/inputs/button";
import CheckBox from "../../../../../components/inputs/checkbox";
import RichTextEditor from "@mantine/rte";
import TextField from "../../../../../components/inputs/textfield";
import DatePickerField from "../../../../../components/inputs/datepicker";
import Snackbar from "../../../../../components/snackbar/snackbar";
import TextEditer from "../../../../../components/inputs/texteditor";
import { admin_careers_add, admin_career_update } from "../../../admin.api";
import "./dialog.css";

let required = ["description", "title", "title_ma", "description_ma", "due_date"];

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      formData: props.formData,
      edit: props.edit,
      submitted: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
      fileError: false,
      fileChange: false,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
    });
  };
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };
  handleDueDateChange = (e) => {
    const date = e?.value || null;
    this.setState({
      formData: {
        ...this.state.formData,
        due_date: date,
      },
    });
  };
  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };

  handleSubmit = (e) => {
    const error = FormValidate(this.state.formData, required);
    console.log(error);
    const { edit, formData, fileChange, fileError } = this.state;
    e.preventDefault();
    // Normalize payload (especially due_date)
    const normalized = { ...formData };
    if (normalized?.due_date) {
      const raw = normalized.due_date;
      let isoDate = null;
      if (raw instanceof Date && !isNaN(raw)) {
        isoDate = raw.toISOString().slice(0, 10);
      } else if (typeof raw === "string") {
        const ddmmyyyy = raw.match(/^([0-3]?\d)-([0-1]?\d)-(\d{4})$/);
        if (ddmmyyyy) {
          const [, dd, mm, yyyy] = ddmmyyyy;
          isoDate = `${yyyy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
        } else {
          const d = new Date(raw);
          if (!isNaN(d)) isoDate = d.toISOString().slice(0, 10);
        }
      }
      if (isoDate) normalized.due_date = isoDate;
    }

    const hasNewFile =
      fileChange &&
      normalized?.file &&
      typeof normalized.file !== "string";

    const payload = new FormData();
    Object.keys(normalized).forEach((key) => {
      if (key === "file") {
        // Only send binary file when a new File object is selected
        if (hasNewFile && normalized.file instanceof File) {
          payload.append("file", normalized.file);
        }
      } else if (key !== "file_name") {
        payload.append(key, normalized[key]);
      }
    });

    if (Object.keys(error).length === 0 && !fileError) {
      if (edit) {
        const updateBody = hasNewFile
          ? payload
          : (() => {
              const { file, file_name, ...rest } = normalized || {};
              return rest;
            })();
        admin_career_update(normalized?.id, updateBody)
          .then((res) => {
            this.setState({
              submitted: true,

              snackMessage: res.message,
              isSnackError: false,
              snackOpen: true,
            });
            this.props.handleEventList();
          })
          .catch((error) => {
            this.setState({
              submitted: false,
              snackMessage: error.message,
              isSnackError: true,
              snackOpen: true,
            });
          });
      } else {
        admin_careers_add(payload)
          .then((res) => {
            this.setState({
              submitted: true,

              snackMessage: res.message,
              isSnackError: false,
              snackOpen: true,
            });
            this.props.handleEventList();
          })
          .catch((error) => {
            this.setState({
              submitted: false,
              snackMessage: error.message,
              isSnackError: true,
              snackOpen: true,
            });
          });
      }
    } else {
      this.setState({
        submitted: false,
        snackMessage: "Please fill all mandatory fields",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };
  handleSelect = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        parent_id: e.target.value,
      },
    });
  };
  handleFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();
    //console.log(e.target.files[0]);
    if (
      type?.toLowerCase() === "pdf" ||
      type?.toLowerCase() === "doc" ||
      type?.toLowerCase() === "docx"
    ) {
      let mb = size / Math.pow(1024, 2);

      if (mb < 5) {
        this.setState({ fileChange: true });
        this.setState({ fileError: false });
        this.setState({
          formData: {
            ...this.state.formData,
            file: e.target.files[0],
            file_name: e.target.files[0].name,
          },
        });
      } else {
        this.setState({ fileError: true });
        this.setState({
          formData: { ...this.state.formData, file: null, file_name: null },
        });
      }
    } else {
      this.setState({ fileError: true });
      this.setState({
        formData: { ...this.state.formData, file: null, file_name: null },
      });
    }
  };
  handleEditorChange = (value, fieldName) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [fieldName]: value,
      },
    });
  };

  render() {
    const { submitted, formData, open, edit } = this.state;
    const { view } = this.props;
    console.log(formData)
    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <div className="overlay">
              <div className="big-dia-career-admin h-auto">
                <Snackbar
                  message={this.state.snackMessage}
                  error={this.state.isSnackError}
                  open={this.state.snackOpen}
                  close={this.snackbarClose}
                />
                <div className="row">
                  <div className="flexDisplay">
                    <div className="diaTitleCon">
                      {edit ? "Edit Career" : view ? "Career" : "Add Career"}
                    </div>
                    <div className="dia-close" onClick={this.props.handleClose}>
                      <div className="diaCloseCon">
                        <div className="diaClose">&#10005;</div>
                      </div>
                    </div>
                  </div>
                  <div className="tilebars">
                    <hr />
                  </div>
                  <form action="">
                    <div className="row book-form">
                      <div className="content-scroll-xx">
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            name="title"
                            onChange={(e) => this.handleChange(e)}
                            label="Title[Eng]"
                            disabled={view}
                            value={formData?.title ?? ""}
                            variant="outlined"
                            multiline
                            required
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            name="title_ma"
                            onChange={(e) => this.handleChange(e)}
                            label="Title[Mal]"
                            disabled={view}
                            value={formData?.title_ma ?? ""}
                            variant="outlined"
                            multiline
                            required
                          />
                        </div>
                        <div className="col-12">
                          <label className="mylabel">Description[Eng]</label>
                          <TextEditer
                            value={formData?.description ?? ""}
                            onChange={(e) =>
                              this.handleEditorChange(e, "description")
                            }
                            disabled={view}
                            name="description"
                            required
                          />
                        </div>
                        <div className="col-12">
                          <label className="mylabel">Description[Mal]</label>
                          <TextEditer
                            value={formData?.description_ma ?? ""}
                            onChange={(e) =>
                              this.handleEditorChange(e, "description_ma")
                            }
                            disabled={view}
                            name="description_ma"
                            required
                          />
                        </div>

                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            name="link"
                            onChange={(e) => this.handleChange(e)}
                            label="Link"
                            disabled={view}
                            value={formData?.link ?? ""}
                            variant="outlined"
                          />
                        </div>
                        <div className="col-12">
                          <DatePickerField
                            id="due-date"
                            label="Due Date"
                            name="due_date"
                            disabled={view}
                            value={formData?.due_date ?? null}
                            onChange={this.handleDueDateChange}
                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            type="file"
                            // view="straight"
                            id="outlined-basic"
                            onChange={(e) => this.handleFileChange(e)}
                            label="File"
                            variant="outlined"
                            disabled={view}
                            fileName={
                              formData?.file_name
                                ? formData?.file_name
                                : formData?.file
                                ? formData?.file
                                : ""
                            }
                            accept=".pdf,.docx,.doc"
                            // required
                          />
                          {this.state.fileError && (
                            <div className="file-up-helper text-center">
                              *Upload only .pdf , .doc, .docx and Size should be
                              less than 1MB
                            </div>
                          )}
                        </div>
                      </div>
                      {!view && (
                        <div className="col-12">
                          <CustomButton
                            label={edit ? "Update" : "Add"}
                            disabled={submitted}
                            onClick={(e) => this.handleSubmit(e)}
                          />
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default Dialog;
